import React, { useState, useEffect } from 'react';
import documentApi, { Document } from '../../api/documentApi';
import DocumentListHeader from '../../components/archive/document/DocumentListHeader';
import DocumentListFilters from '../../components/archive/document/DocumentListFilters';
import DocumentListTable from '../../components/archive/document/DocumentListTable';

const moduleColors = {
  HRIS: 'bg-green-100 text-green-700',
  CREDIT: 'bg-blue-100 text-blue-700',
  DEBTOR: 'bg-amber-100 text-amber-700',
  LEGAL: 'bg-purple-100 text-purple-700',
  GENERAL: 'bg-gray-100 text-gray-700',
};

const statusColors = {
  draft: 'bg-gray-100 text-gray-700',
  pending_validation: 'bg-amber-100 text-amber-700',
  valid: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  expired: 'bg-red-100 text-red-700',
  archived: 'bg-gray-100 text-gray-700',
};

export default function DocumentList() {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterModule, setFilterModule] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const docs = await documentApi.getAll({ is_deleted: false });
      // Sort by created_date descending
      const sortedDocs = docs.sort((a, b) => {
        const dateA = new Date(a.created_date || 0).getTime();
        const dateB = new Date(b.created_date || 0).getTime();
        return dateB - dateA;
      });
      setDocuments(sortedDocs);
    } catch (error) {
      console.error('Error loading:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredDocuments = documents.filter(doc => {
    const matchSearch =
      doc.document_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.entity_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.document_ref_number?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchModule = filterModule === 'all' || doc.module_type === filterModule;
    const matchStatus = filterStatus === 'all' || doc.status === filterStatus;
    return matchSearch && matchModule && matchStatus;
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <DocumentListHeader />

      <DocumentListFilters
        searchTerm={searchTerm}
        filterModule={filterModule}
        filterStatus={filterStatus}
        onSearchChange={setSearchTerm}
        onModuleChange={setFilterModule}
        onStatusChange={setFilterStatus}
      />

      <DocumentListTable
        documents={filteredDocuments}
        moduleColors={moduleColors}
        statusColors={statusColors}
      />

      <div className="text-sm text-gray-500">
        Menampilkan {filteredDocuments.length} dari {documents.length} dokumen
      </div>
    </div>
  );
}
